var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('animate-x',{staticClass:"absolute",staticStyle:{"transform-origin":"top center"},attrs:{"keyframes":[
      {
        translateX: 0,
        translateY: _vm.windowHeight * .2,
        rotate: 0,
        scale: _vm.scaleFactorTxt,
        opacity: 0,
        duration: 0
      },
      {
        translateX: 0,
        translateY: _vm.windowHeight * .2,
        rotate: 0,
        scale: _vm.scaleFactorTxt,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.startingPoint,"deltaYcounter":_vm.deltaYcounter}},[_c('p',{staticClass:"text-center w-screen text-white",staticStyle:{"font-size":"24px"}},[_vm._v(" Find out more about how we are working"),_c('br'),_vm._v(" to save money and reduce our impact on"),_c('br'),_vm._v(" the environment:"),_c('br'),_c('a',{staticClass:"font-bold text-white underline",attrs:{"href":"https://www.networkrail.co.uk/sustainability"}},[_vm._v("www.networkrail.co.uk/sustainability")])])]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      { // 0%
        translateX: _vm.windowWidth,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: -_vm.windowWidth,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.startingPoint + 300,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-contain bg-no-repeat",style:({'background-image': ("url(" + _vm.train)})})]),_c('animate-x',{staticClass:"absolute w-screen",staticStyle:{"transform-origin":"top center"},attrs:{"keyframes":[
      {
        translateX: 0,
        translateY: _vm.windowHeight,
        rotate: 0,
        scale: _vm.scaleFactorTxt,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: _vm.windowHeight * 0.5,
        rotate: 0,
        scale: _vm.scaleFactorTxt,
        opacity: 1,
        duration: 500
      }
    ],"triggerAt":_vm.startingPoint + 800,"deltaYcounter":_vm.deltaYcounter}},[_c('button',{staticClass:"cursor-pointer flex flex-col items-center mx-auto border-0",on:{"click":_vm.setCounterToCero}},[_c('img',{staticStyle:{"transform":"rotate(180deg)","display":"block","margin-bottom":"20px"},attrs:{"src":_vm.greenArrows,"alt":"green arrows"}}),_c('p',{staticStyle:{"color":"white","font-size":"24px"}},[_vm._v("Back to the top")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }